import React from "react";
import { ILiveComment, ITipResponse, ITop3Tips } from "../../helpers/types";
import { EURO_SYMBOLE } from "../../helpers/constant";
import { getUserColor } from "../../utls/colors";
import LiveTipsLeaderboardComponent from "../LiveTipsLeaderboardComponent/LiveTipsLeaderboardComponent";
import "./index.less";

type props = {
  comments: ILiveComment[] | null;
  tipPrice?: number;
  lastTip?: ITipResponse | null;
  top3Tips?: ITop3Tips[];
};

const LiveBroadcastCommentComponent: React.FC<props> = ({ comments, tipPrice, lastTip, top3Tips }) => {
  const truncateUsername = (username: string) => {
    if (username.length > 10) {
      return username.substring(0, 10) + "...";
    }
    return username;
  };

  const formatTipPrice = (price: number) => {
    if (price > 999) {
      const kValue = price / 1000;
      return `${Math.round(kValue)}k`;
    }
    return Math.round(price).toString();
  };

  return (
    <div className="live-broadcast-comment-container">
      <div className="broadcast-chat-title">
        <span>Chat</span>
        <div className="broadcast-tips-container">
          {lastTip && (
            <div className="broadcast-last-tip">
              <span className="broadcast-tip-username">{truncateUsername(lastTip.username)}</span>
              <span className="broadcast-tip-amount">
                {parseFloat(lastTip.amount).toFixed(2)} {EURO_SYMBOLE}
              </span>
            </div>
          )}
          {tipPrice !== undefined && tipPrice > 0 && (
            <div className="broadcast-total-tip">
              <span className="broadcast-tip-total">
                {formatTipPrice(tipPrice)} {EURO_SYMBOLE}
              </span>
            </div>
          )}
        </div>
      </div>

      {top3Tips && top3Tips.length > 0 && (
        <div className="broadcast-tips-leaderboard-wrapper">
          <LiveTipsLeaderboardComponent topTips={top3Tips} />
        </div>
      )}

      <div className="broadcast-comments-list">
        <div className="broadcast-comments-wrapper">
          {comments?.map((comment, index) => {
            const userColor = getUserColor(comment?.user?.username || "");
            return (
              <div key={index} className="broadcast-comment-item">
                <div className="broadcast-username-text" style={{ color: userColor }}>
                  {comment?.user?.username}
                </div>
                <div className="broadcast-comment-text">{comment?.text}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LiveBroadcastCommentComponent;
